// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailConfigurationStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import UiState from 'logic/Izenda.UiState';
import { observable, computed } from 'mobx';
import { get } from 'lodash/fp';
import EmailConfiguration from './models/Izenda.EmailConfiguration';
import AlertDetails from 'logic/models/Izenda.AlertDetails';
import fetcher from 'fetchers/Izenda.SystemSettingFetcher';

export default class EmailConfigurationStore {
  @observable emailConfiguration = new EmailConfiguration();
  @observable clonedEmailConfiguration = new EmailConfiguration();
  @observable alertDetails = new AlertDetails();

  noDirtyFnRegistration: false; // if true - we don't register dirty function in uiStore.
  // Dirty check function
  dirtyFn = () => {
    return get('emailConfiguration.isDirty', this) || get('clonedEmailConfiguration.isDirty', this);
  };

  constructor(noDirtyFnRegistration: boolean) {
    this.noDirtyFnRegistration = !!noDirtyFnRegistration;
  }

  @computed
  get isShowConfiguration() {
    return UiState.tenantId;
  }

  /**
   * Load email configuration
   */
  loadEmailConfiguration() {
    return fetcher.loadEmailConfiguration(UiState.tenantId).then(result => {
      this.emailConfiguration = new EmailConfiguration(result);
      this.clonedEmailConfiguration = this.emailConfiguration.clone();
      this.resetDirty();
      return result;
    });
  }

  /**
   * Save email configuration
   */
  saveEmailConfiguration() {
    return fetcher.saveEmailConfiguration(this.clonedEmailConfiguration.buildDataForSave()).then(result => {
      if (result.success) {
        this.emailConfiguration.populateData(this.clonedEmailConfiguration);
        this.resetDirty();
      }
      return result;
    });
  }

  /**
   * Cancel change
   */
  cancelChangeConfiguration() {
    this.clonedEmailConfiguration = this.emailConfiguration.clone();
  }

  /**
   * Reset dirty
   */
  resetDirty() {
    this.emailConfiguration.resetDirty();
    this.clonedEmailConfiguration.resetDirty();
  }

  /**
   * Init email configuration store
   */
  init() {
    if (!this.noDirtyFnRegistration)
      UiState.setCheckDirtyFunction(this.dirtyFn);
  }

  /**
   * Destroy email configuration store
   */
  destroy() {
    if (!this.noDirtyFnRegistration)
      UiState.resetCheckDirtyFunction();
  }
}



// WEBPACK FOOTER //
// ./ui/logic/Izenda.EmailConfigurationStore.js